import { render, staticRenderFns } from "./BenefitCard.vue?vue&type=template&id=42afc62e&scoped=true"
import script from "./BenefitCard.vue?vue&type=script&lang=js"
export * from "./BenefitCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitCard.vue?vue&type=style&index=0&id=42afc62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afc62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCol,VImg,VProgressCircular})
